<script>
    import Select from "svelte-select";
    import {getGroupChildrenByMunicipality} from "../../services/groupService";

    let groups = [];
    let previousMunicipalityId;
    export let municipalityId;
    export let value;
    export let handleChange;

    function searchChildrenByMunicipality() {
        getGroupChildrenByMunicipality(municipalityId).then((data) => {
            groups = data?.data?.map((group) => {return {label: group.name, value: group.id}});

            if (value?.value && !groups?.some((group) => group.value === value.value)) {
                if (previousMunicipalityId) {
                    // The user switched municipality and the selected circolo is not
                    // available for the new one: clear it.
                    value = undefined;
                } else {
                    // First load: keep the circolo already associated to the iscritto
                    // even if it doesn't belong to their municipality.
                    groups = [...groups, value];
                }
            }

            previousMunicipalityId = municipalityId;
        })
    }

    $: municipalityId && searchChildrenByMunicipality();

</script>

<Select
    items = {groups}
    id="group"
    type= "text"
    placeholder="Circolo associato"
    on:change={handleChange}
    bind:value={value}
    required={false}
    disabled={!municipalityId}
    class="hover:shadow-md transition-all"
    containerStyles={`
        border: 1px solid #e0e0e0;
        box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%);
        border-radius: 0;
        height: 2.75rem;
        `
    }
>
    <div slot="empty" class="flex justify-center items-center h-20">Nessun circolo presente</div>
</Select>